export default {
  'userManagement.title': 'User List',
  'userManagement.form.username': 'Username',
  'userManagement.form.username.placeholder': 'Please enter username',
  'userManagement.form.email': 'Email',
  'userManagement.form.email.placeholder': 'Please enter email',
  'userManagement.form.phone': 'Phone',
  'userManagement.form.phone.placeholder': 'Please enter phone',
  'userManagement.form.search': 'Search',
  'userManagement.form.reset': 'Reset',
  'userManagement.operation.add': 'Add',
  'userManagement.operation.delete': 'Delete',
  'userManagement.actions.refresh': 'Refresh',
  'userManagement.actions.density': 'Density',
  'userManagement.actions.columnSetting': 'Column Settings',
  'userManagement.columns.index': 'Serial Number',
  'userManagement.columns.avatar': 'Avatar',
  'userManagement.columns.username': 'Username',
  'userManagement.columns.nickname': 'Operation Name',
  'userManagement.columns.merchant': 'Affiliated Merchant',
  'userManagement.columns.role': 'Role',
  'userManagement.columns.email': 'Email',
  'userManagement.columns.phone': 'Phone',
  'userManagement.columns.remark': 'Remark',
  'userManagement.columns.status': 'Status',
  'userManagement.columns.createdAt': 'Creation Time',
  'userManagement.columns.updatedAt': 'Update Time',
  'userManagement.columns.status.enabled': 'Enabled',
  'userManagement.columns.status.disabled': 'Disabled',
  'userManagement.columns.operations': 'Operations',
  'userManagement.columns.operations.edit': 'Edit',
  'userManagement.columns.operations.delete': 'Delete',
  'userManagement.columns.operations.deleteConfirm': 'Are you sure you want to delete this record?',
  'userManagement.size.mini': 'Mini',
  'userManagement.size.small': 'Small',
  'userManagement.size.medium': 'Medium',
  'userManagement.size.large': 'Large',
  'userManagement.modal.title': 'Add New User',
  'userManagement.modal.avatar': 'Avatar',
  'userManagement.modal.merchant': 'Affiliated Merchant',
  'userManagement.modal.merchant.placeholder': 'Please select merchant',
  'userManagement.modal.merchant.required': 'Please select affiliated merchant',
  'userManagement.modal.role': 'Affiliated Role',
  'userManagement.modal.role.placeholder': 'Please select role',
  'userManagement.modal.role.required': 'Please select affiliated role',
  'userManagement.modal.username': 'Username',
  'userManagement.modal.username.placeholder': 'Please enter username',
  'userManagement.modal.username.required': 'Please enter username',
  'userManagement.modal.password': 'Password',
  'userManagement.modal.password.placeholder': 'Please enter password',
  'userManagement.modal.password.required': 'Please enter password',
  'userManagement.modal.nickname': 'Nickname',
  'userManagement.modal.nickname.placeholder': 'Please enter nickname',
  'userManagement.modal.email': 'Email',
  'userManagement.modal.email.placeholder': 'Please enter email',
  'userManagement.modal.phone': 'Phone',
  'userManagement.modal.phone.placeholder': 'Please enter phone',
  'userManagement.modal.remark': 'Remarks',
  'userManagement.modal.remark.placeholder': 'Please enter remarks',
  'userManagement.modal.status': 'Status',
  'userManagement.modal.status.enabled': 'Enabled',
  'userManagement.modal.status.disabled': 'Disabled',
  'userManagement.modal.createSuccess': 'Created successfully',
  'userManagement.modal.createFailed': 'Failed to create',
  'userManagement.modal.editTitle': 'Edit User',
  'userManagement.modal.password.editPlaceholder': 'Leave blank to keep current password',
  'userManagement.modal.updateSuccess': 'Updated successfully',
  'userManagement.modal.updateFailed': 'Failed to update',
  'userManagement.operation.deleteSuccess': 'Deleted successfully',
  'userManagement.operation.deleteFailed': 'Failed to delete',
  'userManagement.operation.noSelection': 'Please select users to operate first',
  'userManagement.operation.batchDeleteConfirm': 'Are you sure you want to delete the selected users?',
  'userManagement.operation.batchDeleteSuccess': 'Batch delete successful',
  'userManagement.operation.batchDeleteFailed': 'Batch delete failed',
  'userManagement.upload.success': 'Avatar uploaded successfully',
  'userManagement.upload.failed': 'Failed to upload avatar',
};

